module.exports = __webpack_public_path__ + "static/media/Screenshot_4-thumb.ddd0eb03.png";